/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_OptionalInputs */

const en_pronunciation_report_optional = /** @type {(inputs: Pronunciation_Report_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional`)
};

const es_pronunciation_report_optional = /** @type {(inputs: Pronunciation_Report_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opcional`)
};

/**
* | output |
* | --- |
* | "Optional" |
*
* @param {Pronunciation_Report_OptionalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_optional = /** @type {((inputs?: Pronunciation_Report_OptionalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_OptionalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_optional(inputs)
	return en_pronunciation_report_optional(inputs)
});